import { observer } from 'mobx-react-lite'
import { storeLocal } from '../helpers/stores'
import { Popover } from 'antd'
import React from 'react'
import i from '../translations/i'

export const ErrorByPricingPlan = observer(({ content, plan = 0, black_mark = false }: any) => {

    if (!(storeLocal.get('pricing_plan') < plan || black_mark)) {
        return content
    }

    // disabled-элемент не генерирует mouse-события, поэтому Popover, навешенный
    // прямо на него, никогда не увидит hover — оборачиваем в обычный span.
    return (
        <Popover placement="bottom" title={black_mark ? i.t('def:errors.blackMarkRestricted') : i.t('def:errors.pricing_plan')}>
            <span style={{ cursor: 'not-allowed' }}>
                {content}
            </span>
        </Popover>
    )
})